import React, { FC } from 'react';
import classNames from 'classnames';

import { useIsMobile } from '../../../../hooks';

import styles from './SkeletonLoaderRow.module.scss';

type SkeletonLoaderRowProps = {
  isPendingOrder?: boolean;
};
const SkeletonLoaderRow: FC<SkeletonLoaderRowProps> = (props: SkeletonLoaderRowProps) => {
  const { isPendingOrder } = props;
  const { isMobile } = useIsMobile();

  if (isMobile) {
    return (
      <div className={styles.loadingRowMobile}>
        <div className={styles.left}>
          <div className={styles.loadingLogo} />
          <div className={styles.companyInfo}>
            <div style={{ width: '40%' }} className={classNames(styles.loadingElement, styles.loadingMargin)} />
            <div style={{ width: '68%' }} className={classNames(styles.loadingElement, styles.loadingMargin, styles.loadingMarginTop)} />
          </div>
        </div>
        <div className={styles.right}>
          <div>
            <div className={styles.loadingElement} />
            <div className={classNames(styles.loadingElement, styles.loadingMarginTop)} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <tr className={styles.loadingRow}>
      <td className={styles.companyTab}>
        <div className={styles.loadingLogo} />
        <div className={styles.loadingElementLg} />
      </td>
      <td>
        <div className={styles.loadingElement} />
      </td>
      <td>
        <div className={styles.loadingElement} />
      </td>
      <td>
        <div className={styles.loadingElement} />
      </td>
      <td>
        <div className={styles.loadingElement} />
      </td>
      {isPendingOrder && (
        <td>
          <div className={styles.loadingElement} />
        </td>
      )}
    </tr>
  );
};

export default SkeletonLoaderRow;
